<script setup lang="ts">
import { computed } from 'vue';
import InputText from 'primevue/inputtext';

interface Props {
  durations: string;
  validateSeason: string | undefined;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:durations': [value: any] }>();

const durationSeasonal = computed({
  get() {
    return props.durations;
  },
  set(value) {
    emits('update:durations', value);
  }
});
</script>
<template>
  <div class="seasonal-duration w-full">
    <p class="mb-1 labels">{{ $t('common.labels.durations') }}</p>
    <InputText id="duration_input" :class="validateSeason ? 'p-invalid w-full' : 'w-full'" type="text" v-model="durationSeasonal" />
    <p class="text-red-500 pt-1 error_message" v-if="validateSeason">{{ validateSeason }}</p>
  </div>
</template>
